import Http from '../Core/Http';
export default class Order extends Http {
  constructor(config) {
    super(config);
  }

  // 门诊 ---------------------------------------------------------------------------------------------------------
  // 根据健康序号获取门诊缴列表POST/api/Interaction/GetOutpatientExpenseList
  GetOutpatientExpenseList(data) {
    return this._post('api/Interaction/GetOutpatientExpenseList', null, data)
  }

  // 获取门诊缴费详情/api/Interaction/GetOutpatientExpenseDetails
  GetOutpatientExpenseDetails(id) {
    return this._post('api/Interaction/GetOutpatientExpenseDetails', null, {
      BillId: id
    })
  }

  // 根据健康序号获取门诊待缴列表POST/api/Interaction/GetOutpatientUnpaidList
  GetOutpatientUnpaidList(id) {
    return this._post('api/Interaction/GetOutpatientUnpaidList', null, {
      CardId: id
    })
  }
    // 根据健康序号获取门诊待缴列表POST/api/Interaction/GetOutpatientUnpaidItem
    GetOutpatientUnpaidItem(data) {
      return this._post('api/Interaction/GetOutpatientUnpaidItem', null, data)
    }

  // 候诊
  // 候诊信息
  GetWaitingInfo(id) {
    return this._post('api/interaction/GetWaitingInfo', null, {
      CardId: id
    })
  }
}



// WEBPACK FOOTER //
// ./src/lib/PMA/Order.js